import $ from 'jquery';
import Immutable from 'immutable';
import BasePropertyView from 'BasePropertyView.js';
import htmlTemplate from 'properties/advanced/locking.ejs';
import TextUtil from 'util/TextUtil.js';

class LockingView extends BasePropertyView {

    initialize(opts) {
        this.options = opts || {};
        this.template = htmlTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=checkbox]': 'updateCheckboxes',
            'change input[type=text]': 'updateAttributes',
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'keydown input[name=timeOut]': 'validatePositiveNumeric'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    validatePositiveNumeric(ev){
      TextUtil.validatePositiveNumeric(ev);
    }

    updateCheckboxes(ev) {
        ev.preventDefault();
        const name = ev.currentTarget.name;
        const isChecked = ev.currentTarget.checked;

        this.model.set(name, isChecked ? "true" : "false");
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        this.model.set(propName, propVal);
    }


    render() {
        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        return this;
    }

}

export default LockingView;
